import { useState } from "react";
import { Image, Button } from "react-bootstrap";
import appImage from "../../Images/downloadApp.png";
import webAppImage from "../../Images/webApp.png";
import overThePhoneImage from "../../Images/overThePhone.png";
import appIntegrationsImage from "../../Images/appIntegrations.png";
import AccessCard from "../../Components/AccessCard/AccessCard";
import qrCode from "../../Images/qrCode.png";
import DashboardHeader from "../../Components/DashboardHeader/DashboardHeader";
import VoyceWebAppPDF from "../../PDFs/VoyceWebAppGuide.pdf";
import Popup from "../../Components/Popup/Popup";
import { useClientUserState } from '../../Contexts/ClientUserStateContext';

import "./AccessInterpreter.css";

const AccessInterpreter = () => {
  const [show, setShow] = useState(false);
  const { clientUser } = useClientUserState();

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const handleIntegration = () => {
    window.open("/ClientSignUp/Integrations", '_self');
  }

  const handleWebApp = () => {
    // redirect in a new tab
    window.open("/client/work.aspx?Company=VoyceInterpreter", "_blank");
  }

  
  return (
    <div className="interpreter-container">
      <DashboardHeader title="Access Interpreter" />
      <div className="interpreter-cards">
        <AccessCard
          image={appImage}
          title="Install the Voyce App"
          description="Get started by downloading the Voyce app on your iOS or Android device. Log in using your account credentials."
          input={
            <Button className="access-btn-primary" onClick={() => handleShow()}>
              Scan QR Code
            </Button>
          }
        />
        <AccessCard
          image={webAppImage}
          title="Interpretation via Web Browser"
          description={
            <>
              {"Access Voyce directly through your browser and log in with your account credentials. \
              Follow the guide linked "}
              <a style={{ cursor: "pointer" }}
                href={VoyceWebAppPDF} target="_blank" rel="noreferrer"
                className="text-button underline"
              >
                here
              </a>
              {" to learn more."}
            </>
          }
          input={<Button className="access-btn-primary" onClick={handleWebApp}>Launch Platform</Button>}
        />
        <AccessCard
          image={overThePhoneImage}
          title="Over The Phone Interpretation (OPI)"
          description={`Call the provided number to connect with an interpreter over the phone.
             When prompted, state the assigned access code, which identifies your company name. `}
          input={<><strong>{"+1(888)488-1980"}</strong><>{`Your Access Code: ${clientUser.OPIPin}`}</></>}
        />
        <AccessCard
          image={appIntegrationsImage}
          title="Integrations Solutions"
          description=" Invite interpreters to meetings hosted on video 
                        conferencing platforms such as  Zoom, Microsoft 
                        Teams, and Cisco WebEx"
          input={<Button onClick={handleIntegration} className="access-btn-primary">Learn More</Button>}
        />
      </div>
      <Popup
        className="qr-popup"
        show={show}
        handleClose={handleClose}
        header={<h2>Access Interpreter</ h2>}
        title={<h3>QR Code</h3>}
        body={
          <>
            <p>Scan the QR code with your mobile device to download the Voyce app</p>
            <Image src={qrCode} alt="QR Code" className="qr-code" />
            <div style={{marginBottom: "50px"}}></div>
          </>
        }
      />
    </div>
  );
};

export default AccessInterpreter;
